import { memo } from "react";
import styles from "./userLocationMarker.module.scss";

interface UserLocationMarkerProps {
  className?: string;
}

export const UserLocationMarker = memo(function UserLocationMarker({
  className
}: UserLocationMarkerProps) {
  return (
    <div
      className={`${styles.marker}${className ? ` ${className}` : ""}`}
    >
      <div className={styles.inner} />
    </div>
  );
});
